import React from 'react';
import Layout from '../components/Layout';
import { formatMarkdown } from '../components/LegalModal';
import { termsOfUse } from '../content/terms-of-use';
import { privacyPolicy } from '../content/privacy-policy';
import '../components/LegalModal.css';

interface LegalPageProps {
  type: 'terms' | 'privacy';
}

const LegalPage: React.FC<LegalPageProps> = ({ type }) => {
  const content = type === 'terms' ? termsOfUse : privacyPolicy;

  return (
    <Layout navigationMode="home-only">
      <div className="legal-content text-body-color">
        <div dangerouslySetInnerHTML={{ __html: formatMarkdown(content) }} />
      </div>
    </Layout>
  );
};

export default LegalPage;
